// extracted by mini-css-extract-plugin
export default {"groupForm":"AddMoney_groupForm__ByRDR","fieldSet":"AddMoney_fieldSet__Xqlgr"};